import { render, staticRenderFns } from "./CreateNewsExtra.vue?vue&type=template&id=227aab1e&scoped=true"
import script from "./CreateNewsExtra.vue?vue&type=script&lang=js"
export * from "./CreateNewsExtra.vue?vue&type=script&lang=js"
import style0 from "./CreateNewsExtra.vue?vue&type=style&index=0&id=227aab1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227aab1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227aab1e')) {
      api.createRecord('227aab1e', component.options)
    } else {
      api.reload('227aab1e', component.options)
    }
    module.hot.accept("./CreateNewsExtra.vue?vue&type=template&id=227aab1e&scoped=true", function () {
      api.rerender('227aab1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/CreateNewsExtra.vue"
export default component.exports